"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryPartnerStatus = exports.TDeliveryOptions = void 0;
var TDeliveryOptions;
(function (TDeliveryOptions) {
    TDeliveryOptions["Self"] = "self";
    TDeliveryOptions["DoorDash"] = "doorDash";
})(TDeliveryOptions = exports.TDeliveryOptions || (exports.TDeliveryOptions = {}));
var DeliveryPartnerStatus;
(function (DeliveryPartnerStatus) {
    DeliveryPartnerStatus["Quote"] = "quote";
    DeliveryPartnerStatus["Created"] = "created";
    DeliveryPartnerStatus["Confirmed"] = "confirmed";
    DeliveryPartnerStatus["EnrouteToPickup"] = "enroute_to_pickup";
    DeliveryPartnerStatus["ArrivedAtPickup"] = "arrived_at_pickup";
    DeliveryPartnerStatus["PickedUp"] = "picked_up";
    DeliveryPartnerStatus["EnrouteToDropoff"] = "enroute_to_dropoff";
    DeliveryPartnerStatus["ArrivedAtDropoff"] = "arrived_at_dropoff";
    DeliveryPartnerStatus["Delivered"] = "delivered";
    DeliveryPartnerStatus["EnrouteToReturn"] = "enroute_to_return";
    DeliveryPartnerStatus["ArrivedAtReturn"] = "arrived_at_return";
    DeliveryPartnerStatus["Returned"] = "returned";
    DeliveryPartnerStatus["Cancelled"] = "cancelled";
})(DeliveryPartnerStatus = exports.DeliveryPartnerStatus || (exports.DeliveryPartnerStatus = {}));
//# sourceMappingURL=delivery.js.map